import React from 'react';
import { Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../providers/AuthProvider';

import HomeIcon from '@mui/icons-material/Home';
import ArticleIcon from '@mui/icons-material/Article';
import PersonIcon from '@mui/icons-material/Person';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const MenuContainer = styled.section`
  width: 100%;
  background-color: var(--white);
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.25);
  position: fixed;
  bottom: 0;
  left: 0;

  
  nav ul {
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    li {
      width: 100%;
      
      div {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0.25rem;

        &.selected {
          background-color: var(--gray-300);
        }
      }
    }
  }
`;

export const MenuMobile = () => {
  const { user } = useAuth();
  const location = useLocation();

  return (
    <MenuContainer>
      <nav>
        <ul>
          <li>
            <Link to='/cupom'>
              <div className={location.pathname === '/cupom' ? 'selected' : ''}>
                <HomeIcon className='black--text' />
                <Typography variant='caption' className='black--text'>
                  Cupons
                </Typography>
              </div>
            </Link>
          </li>
          <li>
            <Link to='/regulamento-e-faq'>
              <div className={location.pathname === '/regulamento-e-faq' ? 'selected' : ''}>
                <ArticleIcon className='black--text' />
                <Typography variant='caption' className='black--text'>
                  Regulamento
                </Typography>
              </div>
            </Link>
          </li>
          <li>
            <Link to='/minha-conta'>
              <div className={location.pathname === '/minha-conta' ? 'selected' : ''}>
                <PersonIcon className='black--text' />
                <Typography variant='caption' className='black--text'>
                  {String(user.name).split(' ')[0] || 'Conta'}
                </Typography>
              </div>
            </Link>
          </li>
        </ul>
      </nav>
    </MenuContainer>
  )
}
